<div>
  @switch (cachedIssueType) {
    @case (AcmCertificateNotFoundIssue.displayName) {
      <certificate-not-found-issue [issue]="issue.issue"> </certificate-not-found-issue>
    }
    @case (ClientErrorIssue.displayName) {
      <client-error-issue [issue]="issue.issue"></client-error-issue>
    }
    @case (RefreshClientErrorIssue.displayName) {
      <refresh-client-error-issue [issue]="issue.issue"></refresh-client-error-issue>
    }
    @case (SyncPairPermissionIssue.displayName) {
      <sync-pair-permission-issue [application]="application" [sync-pair]="syncPair" [issue]="issue.issue">
      </sync-pair-permission-issue>
    }
    @case (SyncPairPermissionIssue.insufficientIamPermissionIssueDisplayName) {
      <iam-permission-issue
        [application]="application"
        [sync-pair]="syncPair"
        [issue]="issue.issue"
      ></iam-permission-issue>
    }
    @case (QuotaIssue.displayName) {
      <quota-issue [issue]="issue.issue"></quota-issue>
    }
    @case (MalwareScanIssue.issueType) {
      <malware-scan-issue [issue]="issue.issue"></malware-scan-issue>
    }
    @case (MarketplaceAmiCantBeCopiedIssue.displayName) {
      <marketplace-ami-issue [issue]="issue.issue"></marketplace-ami-issue>
    }
    @case (MultipleMatchingImagesIssue.displayName) {
      <multiple-matching-images-issue [issue]="issue.issue"></multiple-matching-images-issue>
    }
    @case (MarketplaceInstanceCantBeCopiedIssue.displayName) {
      <marketplace-instance-issue [issue]="issue.issue"></marketplace-instance-issue>
    }
    @case (MarketplaceActionRequiredIssue.displayName) {
      <marketplace-action-required-issue [issue]="issue.issue"></marketplace-action-required-issue>
    }
    @case (AmiStorageNotAccessibleIssue.displayName) {
      <ami-storage-not-accessible-issue [issue]="issue.issue"></ami-storage-not-accessible-issue>
    }
    @case (KeyPairNotFoundIssue.displayName) {
      <key-pair-not-found-issue [issue]="issue.issue"></key-pair-not-found-issue>
    }
    @case (UnconfiguredAzureBlobContainerIssue.displayName) {
      <unconfigured-azure-blob-container-issue [application]="application" [sync-pair]="syncPair" [issue]="issue">
      </unconfigured-azure-blob-container-issue>
    }
    @case (UnconfiguredS3BucketReplicationIssue.displayName) {
      <unconfigured-bucket-issue [application]="application" [sync-pair]="syncPair" [issue]="issue">
      </unconfigured-bucket-issue>
    }
    @case (DynamoDbBackupModeNotConfiguredIssue.displayName) {
      <dynamodb-backup-mode-issue [application]="application" [sync-pair]="syncPair" [issue]="issue">
      </dynamodb-backup-mode-issue>
    }
    @case (S3BucketReplicationNotConfiguredIssue.displayName) {
      <unconfigured-bucket-replication-issue [sync-pair]="syncPair" [issue]="issue">
      </unconfigured-bucket-replication-issue>
    }
    @case (BucketBackfillFailedIssue.displayName) {
      <bucket-backfill-failed-issue [application]="application" [sync-pair]="syncPair" [issue]="issue">
      </bucket-backfill-failed-issue>
    }
    @case (S3RecoveryBucketNameConflictIssue.displayName) {
      <bucket-name-conflict-issue [application]="application" [issue]="issue"></bucket-name-conflict-issue>
    }
    @case (DrsAgentNotFoundIssue.displayName) {
      <drs-agent-not-found-issue [sync-pair]="syncPair" [application]="application" [issue]="issue">
      </drs-agent-not-found-issue>
    }
    @case (UninstallDrsAgentIssue.displayName) {
      <uninstall-drs-agent-issue [sync-pair]="syncPair" [application]="application" [issue]="issue">
      </uninstall-drs-agent-issue>
    }
    @case (FailbackResourceIssue.displayName) {
      <failback-resource-issue
        [application]="application"
        [sync-pair]="syncPair"
        [issue]="issue"
      ></failback-resource-issue>
    }
    @case (SubscriptionOverageIssue.displayName) {
      <subscription-overage-issue [issue]="issue"></subscription-overage-issue>
    }
    @case (DetailedIssue.issueType) {
      <detailed-issue [issue]="issue.issue" [sync-pair]="syncPair" [application]="application"></detailed-issue>
    }
    @case (EksClusterAccessDeniedIssue.displayName) {
      <eks-cluster-permission-issue [issue]="issue.issue"></eks-cluster-permission-issue>
    }
    @case (EksRequiredEndpointInaccessibleIssue.displayName) {
      <eks-required-endpoint-inaccessible-issue [issue]="issue.issue"></eks-required-endpoint-inaccessible-issue>
    }
    @case (ResourcePolicyDeniedIssue.displayName) {
      <resource-policy-permission-issue
        [issue]="issue.issue"
        [viewableIssue]="this.issue"
      ></resource-policy-permission-issue>
    }
    @case (ServiceControlPolicyDeniedIssue.displayName) {
      <service-control-policy-permission-issue
        [issue]="issue.issue"
        [viewableIssue]="this.issue"
      ></service-control-policy-permission-issue>
    }
    @case (NewTargetPlanRequiredIssue.displayName) {
      <new-target-plan-required-issue
        [issue]="issue.issue"
        [application]="application"
      ></new-target-plan-required-issue>
    }
    @case (PersistentIssue.displayName) {
      <persistent-issue [application]="application" [sync-pair]="syncPair" [issue]="issue"> </persistent-issue>
    }
    @default {
      <default-issue [issue]="issue.issue"></default-issue>
    }
  }
</div>
